import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  useDataModel,
  params,
  arrayOf as arrayType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { EducationalSummary } from '@thd-olt-component-react/educational-summary';
import { DeliveryInstallationDetails } from './DeliveryInstallationDetails/DeliveryInstallationDetails';
import { getApplianceText, getVideoId } from './constants';

const title = 'Delivery and Installation';

export const DeliveryAndInstallation = ({ itemId }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('delivery-and-installation.ready'); }, []);

  const opts = {
    variables: {
      itemId
    }
  };

  const { data, loading, error } = useDataModel('product', opts);

  let applianceText = null;
  if (!loading) {
    if (!data || !data.product || error) {
      return null;
    }

    if (data?.product?.media?.video.length < 1) {
      return null;
    }

    if (data?.product?.media?.video.length < 2) {
      return (
        <EducationalSummary itemId={itemId} title={title} maxVideos={2} />
      );
    }

    const videoId = getVideoId(data?.product?.media?.video);
    const details = data.product.specificationGroup.find((group) => group.specTitle === 'Details');
    const applianceType = details.specifications.find((spec) => spec.specName === 'Appliance Type');
    const dryerType = applianceType?.specValue;

    applianceText = getApplianceText(videoId, dryerType);
  }

  return (
    <div className="delivery-and-installation">
      <EducationalSummary itemId={itemId} title={title} showDetails={!!applianceText || loading} maxVideos={2}>
        <DeliveryInstallationDetails applianceText={applianceText} loading={loading} />
      </EducationalSummary>
    </div>
  );
};

DeliveryAndInstallation.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shapeType({
      productLabel: stringType()
    }),
    specificationGroup: arrayType(shapeType({
      specTitle: stringType(),
      specifications: arrayType(shapeType({
        specName: stringType(),
        specValue: stringType()
      }))
    })),
    media: shapeType({
      video: arrayType(shapeType({
        link: shapeType({
          text: stringType(),
          url: stringType()
        }),
        shortDescription: stringType(),
        title: stringType(),
        type: stringType(),
        videoId: stringType()
      }))
    })
  })
};

DeliveryAndInstallation.propTypes = {
  itemId: PropTypes.string.isRequired
};

DeliveryAndInstallation.displayName = 'DeliveryAndInstallation';